<template>
<div id="pageDashboard">
    <v-container grid-list-xl fluid>
        <v-dialog v-model="deleteModal" persistent max-width="290">
            <v-card>
                <v-toolbar color="orange" dark small>
                    <v-toolbar-title>Delete </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn dark icon @click="deleteModal=false">
                        <v-icon>close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card-text>
                    Are you sure you want to delete this ?
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="dark" small @click="deleteModal=false">
                        No
                    </v-btn>
                    <v-btn color="orange " class="white-text" small @click="deleteIMR">
                        Yes
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-toolbar card color="white">
            <v-toolbar-title>
                <h3 id="MyIMRCodes">MY IMR CODES</h3>
                 <p class="subtitle">Below is a list of all the current codes available.</p>
            </v-toolbar-title>
            <v-spacer></v-spacer>
       
        </v-toolbar>

        <v-layout wrap>
            <v-flex xs12>
                <template>
                    <v-card>
                        <v-card-text class="pa-0 mt-2">
                            <v-spacer></v-spacer>
                            <v-layout row wrap>
                               
                            </v-layout>
                            <v-spacer></v-spacer>
                            <v-data-table :disable-initial-sort="true" :headers="headers" :items="imrsList" :rows-per-page-items="[10,25,50,{text:'All','value':-1}]" class="elevation-1">
                                <template slot="items" slot-scope="props">
                                    <td>{{ props.item.code_name }} </td>
                                    <td>{{ props.item.Source.name }}</td>
                                    <td>{{ props.item.description }}</td>
                                    <td>{{ props.item.creationDate }}</td>
                                    <td>{{ props.item.startDate }}</td>
                                    <td>{{ props.item.endDate }}</td>
                                    <td>
                                        <v-switch
                                            label=""
                                            @change="changeDisable(props.item,props.index)"
                                            v-model="props.item.disable"
                                        ></v-switch>
                                    </td>
                                    <td>
                                        <v-tooltip top>
                                            <v-btn slot="activator" class="remove-border" @click="onEdit(props.item)" depressed outline icon fab dark color="orange" small>
                                                <v-icon>fa-edit</v-icon>
                                            </v-btn>
                                            <span>Edit</span>
                                        </v-tooltip>
                                        <v-tooltip top>
                                            <v-btn slot="activator" @click="copyToClipboard(props.item)" class="remove-border" depressed outline icon fab dark color="orange" small>
                                                <v-icon class="main_ic" color="orange">assignment</v-icon>
                                            </v-btn>
                                            <span>Copy link to share</span>
                                        </v-tooltip>
                                        <v-tooltip top>
                                            <v-btn slot="activator" @click="showDeleteModal(props.item.uuid)" class="remove-border" depressed outline icon fab dark color="orange" small>
                                                <v-icon class="main_ic" color="orange">fa-trash</v-icon>
                                            </v-btn>
                                            <span>Delete</span>
                                        </v-tooltip>
                                    </td>
                                </template>
                            </v-data-table>

                            <v-divider></v-divider>
                        </v-card-text>
                    </v-card>
                </template>
            </v-flex>
        </v-layout>

        <v-toolbar id="CreateCode" card color="white">
            <v-toolbar-title>
                <h3>Create Code</h3>
                <p class="subtitle">Create your custom codes below.</p>
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-layout row wrap>
                <p></p>
            </v-layout>
        </v-toolbar>

        <v-layout wrap>
            <v-flex xs12>
                <template>
                    <v-card>
                        <v-card-text class="pa-0 mt-2">
                            <v-container grid-list-xl fluid>
                                <v-layout row wrap>
                                    <v-flex lg4 md4 xs12>
                                        <v-text-field label="Code Name *" :maxlength="32" v-model="form.code_name" v-validate="{required: 'form.code_name', max: 32,'restrictedWord':[]}" data-vv-name="code_name" placeholder="" :error-messages="errors.collect('code_name')" required data-vv-as="Code Name">
                                        </v-text-field>
                                    </v-flex>
                                    <v-flex lg4 md4 xs12>
                                        <v-select class="custom_dropdown" v-validate="{'required':true}" :items="source_arr" :error-messages="errors.collect('source_uuid')" data-vv-name="source_uuid" v-model="form.source_uuid" required data-vv-as="Source" item-text="name" item-value="uuid" label="Source *">
                                        </v-select>
                                    </v-flex>
                                    <v-flex lg4 md4 xs12>
                                        <v-text-field class="custom-picker-text" id="creation_date" v-validate="{'required':true}" data-vv-name="creation_date" data-vv-as="Creation Date" :error-messages="errors.collect('creation_date')" slot="activator" label="Creation Date *" :value="displayDate(form.creation_date)" prepend-icon="event" disabled>
                                        </v-text-field>
                                        </v-menu>
                                    </v-flex>
                                </v-layout>
                                <v-layout row wrap>
                                    <v-flex lg12 md12 xs12>
                                        <v-text-field label="Description *" :maxlength="32" v-model="form.description" v-validate="{required: 'form.description', max: 32,'restrictedWord':[]}" data-vv-name="description" placeholder="" :error-messages="errors.collect('description')" required data-vv-as="Description">
                                        </v-text-field>
                                    </v-flex>
                                </v-layout>

                                <v-layout row wrap>
                                    <v-flex lg6 md6 xs12>
                                        <v-menu ref="picker_start_date" lazy :close-on-content-click="false" v-model="form.picker_start_date" transition="scale-transition" offset-y full-width :nudge-right="40" min-width="290px" :return-value.sync="form.start_date">
                                            <v-text-field class="custom-picker-text" id="start_date" data-vv-name="start_date" data-vv-as="Start Date" :error-messages="errors.collect('start_date')" slot="activator" label="Start Date" :value="displayDate(form.start_date)" prepend-icon="event" readonly>
                                            </v-text-field>
                                            <v-date-picker :min="minDate" v-model="form.start_date" no-title scrollable @input="changeDate('start_date'); $refs.picker_start_date.save(form.start_date)" :value="displayDate(form.start_date)">
                                            </v-date-picker>
                                        </v-menu>
                                    </v-flex>
                                    <v-flex lg6 md6 xs12>
                                        <v-menu ref="picker_end_date" lazy :close-on-content-click="false" v-model="form.picker_end_date" transition="scale-transition" offset-y full-width :nudge-right="40" min-width="290px" :return-value.sync="form.end_date">
                                            <v-text-field class="custom-picker-text" id="end_date" v-validate="{start_date_req:[form.start_date],end_date_valid:[form.start_date]}" data-vv-name="end_date" data-vv-as="End Date" :error-messages="errors.collect('end_date')" slot="activator" label="End Date" :value="displayDate(form.end_date)" prepend-icon="event" readonly>
                                            </v-text-field>
                                            <v-date-picker :min="minDate" v-model="form.end_date" no-title scrollable @input="changeDate('end_date'); $refs.picker_end_date.save(form.end_date)" :value="displayDate(form.end_date)">
                                            </v-date-picker>
                                        </v-menu>
                                    </v-flex>

                                </v-layout>
                                <div class="form-btn text-xs-right">
                                  <v-btn @click="resetForm" color="gray white--text"><v-icon color="white">fa-times-circle</v-icon>Cancel</v-btn>
                                  <v-btn @click="submit" color="orange white--text" slot="activator"> Save </v-btn>
                                </div>
                            </v-container>

                        </v-card-text>
                    </v-card>
                </template>
            </v-flex>
        </v-layout>
    </v-container>

</div>
</template>

<script>
import API from "@/api";
import VWidget from "@/components/VWidget";
import Material from "vuetify/es5/util/colors";
import moment from "moment";
import axios from "axios";
import config from "../../config";
import services from "../../services/HttpService";
import GoogleAds from "@/pages/widgets/GoogleAds";
import {Validator} from 'vee-validate';
import {scroller} from 'vue-scrollto/src/scrollTo'

Validator.extend('start_date_req', {
    getMessage: field => 'Please select the start date',
    validate: function (value, [start_date]) {
        if(!start_date){
            return false;
        }
        return true;
    }
});
Validator.extend('end_date_valid', {
    getMessage: field => 'End date should be greater than start date',
    validate: function (value, [start_date]) {
        if(moment(start_date).format('MMM DD, YYYY') > moment(value).format('MMM DD, YYYY')){
            return false;
        }
        return true;
    }
});

export default {
    components: {
        VWidget,
        GoogleAds,

    },
    computed: {
        minDate() {
            const today = new Date();
            return this.formatDate(today);
        },
    },
    mounted() {
        const self = this;
    },
    created (){
        const self = this,
            wApp = window.getApp;
        wApp.$emit("showLoader", {
            show: true
        });
        axios.all([
                self.getImrsList()
                    .then(dataResults => {
                        return dataResults;
                })
                .catch(err => {
                    console.log(err)
                }),
                services.get("sources/list", {
                    'Authorization': 'Bearer ' + this.$store.state.user.token
                })
            ])
            .then(axios.spread(function (imrs, sources) {
                wApp.$emit("showLoader", {
                    show: false
                });
                // self.imrsList = imrs.data.data;
                self.imrsList = imrs.data.data.map(function(val){
                    val.startDate = (moment(val.start_date).format("YYYY") == '0001' ? null : moment(val.start_date).format("MMM DD, YYYY") );
                    val.endDate = (moment(val.end_date).format("YYYY") == '0001' ? null : moment(val.end_date).format("MMM DD, YYYY") );
                    val.creationDate = (moment(val.creation_date).format("YYYY") == '0001' ? null : moment(val.creation_date).format("MMM DD, YYYY") );
                    return val;
                });

                self.source_arr.push({
                    'name': 'Please Select Source',
                    'uuid': ''
                });
                if (sources.data.data.length > 0) {
                    sources.data.data.map(function (data) {
                        let newArr = {};
                        newArr.name = data.name;
                        newArr.uuid = data.uuid;
                        self.source_arr.push(newArr);
                    })
                }
            }))
            .catch(function (err) {
                wApp.$emit("showLoader", {
                    show: false
                });
                // self._showToast(err.message, config.errMsgColorStr);
            });
    },
    methods: {
        _showToast(msg, color) {
            window.getApp.$emit("showSnackbar", {
                color,
                msg
            });
        },
        changeDisable(data, index){
            const self = this,
                wApp = window.getApp;          
            const formData = {};
            formData.uuid = data.uuid;
            formData.status = data.disable ? 1:0;
            services.put("imrs/update-status", formData,  {
                Authorization: "Bearer " + self.$store.state.user.token
            })
            .then(res => {
                if(res.data.status){
                    self._showToast(res.data.message, 'green');
                    // self.imrsList[index].disable = (data.disable)?1:0;
                } else {
                    self.imrsList.map(function(val,i){
                        if(val.uuid == data.uuid){
                            self.imrsList[i].disable = (data.disable)?false:true;
                        }                    
                    });
                }
            })
            .catch(err => {
                self.imrsList.map(function(val,i){
                    if(val.uuid == data.uuid){
                        self.imrsList[i].disable = (data.disable)?false:true;
                    }                    
                });
                console.log(err)
            });
        },
        makeid(length) {
            var result           = '';
            var characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
            var charactersLength = characters.length;
            for ( var i = 0; i < length; i++ ) {
                result += characters.charAt(Math.floor(Math.random() * charactersLength));
            }
            return result;
        },
        displayDate(selectedDate) {
            if(!selectedDate) {
                return '';
            }
            return moment(selectedDate).format(config.displayDateFormat);
        },
        formatDate(date) {
            let month = `${date.getMonth() + 1}`;
            let day = `${date.getDate()}`;
            const year = date.getFullYear();

            if (month.length < 2) month = `0${month}`;
            if (day.length < 2) day = `0${day}`;

            return [year, month, day].join('-');
        },
        changeDate(id) {
            const self = this;
            let evt = document.createEvent("HTMLEvents");
            evt.initEvent("input", false, true);
            setTimeout(function () {
                document.getElementById(id).dispatchEvent(evt);
            }, 10)
        },
        getImrsList(){
            const self = this;
            return new Promise(function(resolve, reject) {
                services.get("imrs/list", {
                    Authorization: "Bearer " + self.$store.state.user.token
                })
                .then(res => {
                    resolve(res)
                })
                .catch(err => {
                    reject(err)
                });                
            });
        },
        submit() {
            const self = this,
                wApp = window.getApp;
            this.$validator
                .validateAll()
                .then(isValid => {
                    if (isValid) {
                        wApp.$emit("showLoader", {
                            show: true
                        });
                        const formData = Object.assign({}, self.form);
                        let apiUrl = "imrs/new";
                        let apiService = "post";
                        if(self.form.uuid){
                            apiUrl = "imrs/edit";
                            apiService = "put";
                            //delete formData.creation_date;
                            delete formData.Source;
                        } else {
                            formData.code = self.makeid(8);
                        }
                        formData.start_date = (moment(formData.start_date).format("YYYY") == '0001') ? null : moment(formData.start_date).format("YYYY-MM-DD");
                        formData.end_date = (moment(formData.end_date).format("YYYY") == '0001') ? null : moment(formData.end_date).format("YYYY-MM-DD");
                        formData.creation_date = (moment(formData.creation_date).format("YYYY") == '0001') ? null : moment(formData.creation_date).format("YYYY-MM-DD");
                        services[apiService](apiUrl, formData, {
                                    Authorization: "Bearer " + this.$store.state.user.token
                                })
                            .then(res => {
                                if (res.data.status) {
                                    self._showToast(res.data.message, 'green');
                                    self.updateImrList();
                                } else {
                                    wApp.$emit("showLoader", {
                                        show: false
                                    });
                                    self._showToast(res.data.message, 'red');
                                }
                            })
                            .catch(err => {
                                wApp.$emit("showLoader", {
                                    show: false
                                });
                                self._showToast(err.message, 'red');
                            });
                    }
                })
                .catch(err => {});
        },
        onEdit(itemValue){
            const self = this;
            self.form = Object.assign({}, itemValue);
            self.form.start_date = (moment(self.form.start_date).format("YYYY") == '0001') ? null : moment(self.form.start_date).format("YYYY-MM-DD");
            self.form.end_date = (moment(self.form.end_date).format("YYYY") == '0001') ? null : moment(self.form.end_date).format("YYYY-MM-DD");
            self.form.creation_date = (moment(self.form.creation_date).format("YYYY") == '0001') ? null : moment(self.form.creation_date).format("YYYY-MM-DD");
            delete self.form.user_uuid;
            let firstScrollTo = scroller();
            firstScrollTo('#CreateCode');
        },
        resetForm(){
            const self = this;
            self.$validator.reset();
            self.form = Object.assign({},self.defaultFormData);
        },
        copyToClipboard (dataObj){
            const self = this;
            let referralUrl = config.imrReferralUrl+"utm_campaign=imr&utm_code="+dataObj.code;
            let textArea = document.createElement("textarea");
            textArea.value = referralUrl;
            document.body.appendChild(textArea);
            textArea.select();
            document.execCommand("Copy");
            textArea.remove();
            self._showToast('Url copied');
        },
        showDeleteModal (imrId){
            const self = this;
            self.deleteIMRId = imrId;
            self.deleteModal = true;
        },
        deleteIMR(){
            const self = this,
            wApp = window.getApp;
            wApp.$emit("showLoader", {
                show: true
            });
            services.delete("imrs/delete", {uuid:self.deleteIMRId}, {
                "Authorization": "Bearer " + self.$store.state.user.token
            })
            .then(res => {
                wApp.$emit("showLoader", {
                    show: false
                });
                if (res.data) {
                    self._showToast(res.data.message);
                } else {
                    self._showToast(config.tryAgainLetterMSG,config.errMsgColorStr);
                }
                self.deleteModal = false;  
                self.deleteIMRId = null;
                self.updateImrList();
            })
            .catch(err => {
                self.deleteModal = false;
                self.deleteIMRId = null;
                wApp.$emit("showLoader", {
                    show: false
                });
                self._showToast(err.message,config.errMsgColorStr);
                self.updateImrList();
            });
        },
        updateImrList(){
            const self = this,wApp = window.getApp;
            wApp.$emit("showLoader", {
                show: true
            });
            self.getImrsList().then(dataResults => {
                self.$validator.reset()
                self.form = Object.assign({},self.defaultFormData);
                self.imrsList = dataResults.data.data.map(function(val,i){
                    val.startDate = (moment(val.start_date).format("YYYY") == '0001' ? null : moment(val.start_date).format("MMM DD, YYYY") );
                    val.endDate = (moment(val.end_date).format("YYYY") == '0001' ? null : moment(val.end_date).format("MMM DD, YYYY") );
                    val.creationDate = (moment(val.creation_date).format("YYYY") == '0001' ? null : moment(val.creation_date).format("MMM DD, YYYY") );
                    return val;
                });
                let firstScrollTo = scroller();
                firstScrollTo('#MyIMRCodes')
                wApp.$emit("showLoader", {
                    show: false
                });
            })
            .catch(err => {
                wApp.$emit("showLoader", {
                    show: false
                });
            });
        }
    },
    data() {
        return {
            showMenu: true,
            dialog: false,
            Checkbox: false,
            picker_start_date: false,
            picker_end_date: false,
            picker_creation_date: false,
            source_arr: [],
            imrsList: [],
            defaultFormData: {
                code_name: '',
                code: '',
                description: '',
                source_uuid: '',
                start_date: null,
                end_date: null,
                creation_date: new Date().toISOString().substr(0, 10),
            },
            form: {
                code_name: '',
                code: '',
                description: '',
                source_uuid: '',
                user_uuid: '',
                start_date: null,
                end_date: null,
                creation_date: new Date().toISOString().substr(0, 10),
            },
            items: [{
                    title: 'Delete'
                },
                {
                    title: 'Share'
                },

            ],
            selected: [],
            pagination: '',
            headers: [{
                    text: 'Code Name',
                    align: 'left',
                    value: 'code_name'
                },
                {
                    text: 'Source',
                    align: 'left',
                    value: 'Source.name'
                },
                {
                    text: 'Description',
                    align: 'left',
                    value: 'description'
                },
                {
                    text: 'Creation Date',
                    align: 'left',
                    value: 'creation_date'
                },
                {
                    text: 'Start Date',
                    align: 'left',
                    value: 'start_date'
                },
                {
                    text: 'End Date',
                    align: 'left',
                    value: 'end_date'
                },
                {
                    text: 'Disable',
                    value: "",
                    sortable: false,
                    align: 'left'
                },
                {
                    text: "Actions",
                    value: "",
                    sortable: false,
                    align: 'left',
                    width: "20%"
                }
            ],
            imrsList: [],
            deleteModal: false,
            deleteIMRId: null
        }
    },
};
</script>

<style lang="stylus">
.custom_table th,.custom_table td
  padding: 5px;
.v-input--selection-controls__ripple, .v-input--selection-controls__input
  height:auto;
  width:auto;
.v-input--selection-controls
  margin-top: 0px; 
.v-btn.remove-border
  border: none !important;
</style>



// WEBPACK FOOTER //
// src/pages/imr/List.vue